import '../beneficiary.scss';

import { uploadBulkBeneficiary } from '@api/beneficiaries';
import { Button, Dropdown, FormInput, Modal } from '@basqet-dashboard/common/components';
import { useCurrencies } from '@basqet-dashboard/common/hooks';
import { bulkBeneficiarySchema, formatErrorMessage } from '@basqet-dashboard/common/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
import React from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

const BulkBeneficiaryModal = ({ onModalClose, uploadRecipients }) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitting, isValid, isDirty }
  } = useForm({ mode: 'onChange', resolver: yupResolver(bulkBeneficiarySchema) });

  const { cryptoCurrencies } = useCurrencies();

  const onSubmit = async (data) => {
    const { csv, label, currency_id } = data;

    const requestBody = new FormData();

    await requestBody.append('csv', csv[0], csv[0].name);
    await requestBody.append('extraData', JSON.stringify({ label, currency_id }));

    try {
      const { data: recipientsData } = await uploadBulkBeneficiary(requestBody);
      await toast.success(
        uploadRecipients ? 'Recipients uploaded successfully' : 'Bulk Beneficiaries uploaded'
      );

      if (uploadRecipients) {
        // The onModal Close for bulk recipients should be able to accept a parameter
        uploadRecipients(recipientsData);
      }
      await reset();
    } catch (error) {
      formatErrorMessage(error);
    }
  };

  return (
    <Modal
      header={{ name: 'Add', cursive: uploadRecipients ? 'Recipients' : 'Bulk Beneficiary' }}
      onModalClose={onModalClose}>
      <form onSubmit={handleSubmit(onSubmit)} className="modal__form beneficiary">
        <Dropdown
          formLabel="Payment Currency"
          placeholder={'Select Payment Currency'}
          name="currency_id"
          id="currency_id"
          options={cryptoCurrencies}
          register={register('currency_id')}
          error={errors?.currency_id?.message}
        />

        <FormInput
          placeholder="Enter a label to identify group"
          name="label"
          id="label"
          label="Group Label"
          type="text"
          register={register('label')}
          error={errors?.label?.message}
        />

        <FormInput
          name="csv"
          id="csv"
          type="file"
          multiple={false}
          accept="text/csv"
          label="For Bulk transfers you are required to put together a list of the wallet address and amount to be deposited in a CSV file."
          register={register('csv')}
          error={errors?.csv?.message}
          control={control}
        />
        <div className="form__group__button">
          <a
            className="btn btn__full btn--outline"
            href="https://basqet-files-public.s3.amazonaws.com/basqet-bulk-payout.csv"
            target="_blank"
            rel="noreferrer">
            Download a sample CSV
          </a>
          <Button disabled={!isDirty || !isValid} isLoading={isSubmitting} isFull>
            {uploadRecipients ? 'Upload Recipients & Continue' : 'Save Beneficiaries'}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

BulkBeneficiaryModal.propTypes = {
  onModalClose: PropTypes.func,
  uploadRecipients: PropTypes.func
};
export { BulkBeneficiaryModal };
